import { ASSET_PATH } from 'assetsPath';
import {
	validEmail,
	validName,
	validPhone,
	formatName,
	getDate
} from 'UtilityComponents/Util';
import { APPLICATION_CONSTANTS, PAGE_URLS, PATHS } from 'AppConstants';

const MICE_IMG_PATH = `${ASSET_PATH.IMAGES}mice/`;
const miceWork1 = `${MICE_IMG_PATH}micework1.png`;
const miceWork2 = `${MICE_IMG_PATH}micework2.png`;
const miceWork3 = `${MICE_IMG_PATH}micework3.png`;

export const NavigationLinks = [
	{
		text: 'HOW IT WORKS?',
		type: 'works',
		link: 'Works',
		trackVal: '',
		pageurl: PAGE_URLS.VENUES
	}];

export const bannerCarouselData = {
	mainHeading: 'Venue Bookings for Corporate Events',
	sliderData: [{
		heading: 'Select a preferred venue in over 600 cities',
		subHeading: 'Looking for the perfect business <span class="highlight-heading">meeeting</span> venue?',
		carouselUrl: {
		}
	}
	]
};

export const HowItWorksData = {
	heading: 'How It Works ?',
	descp: 'Booking a venue is now easy and simple',
	list: [
		{
			id: 1,
			img: miceWork1,
			alt: 'Step 1',
			title: 'Let Us Know Your Requirements',
			descp:
      'Fill the form and provide accurate details.'
		},
		{
			id: 2,
			img: miceWork2,
			title: 'Our experts negotiate with multiple options',
			alt: 'Step 2',
			descp:
      'We inform you about best available deals & prices.'
		},
		{
			id: 3,
			img: miceWork3,
			title: 'Block Your Venue & Confirm',
			alt: 'Step 3',
			descp:
      'You can block the venue for free* and confirm by paying the booking amount.'
		}
	]
};

export const queryFormFields = [
	{
		name: 'requesterDetails.name',
		label: 'Your Name',
		placeHolder: 'Enter your Name',
		value: '',
		nocHangeError: true,
		errorOnBlur: true,
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validName,
				msg: 'Not a valid Name'
			}
		},
		formatSave: formatName,
		type: 'text',
		isMandatory: true,
		outLabel: true,
		mmtTheme: true
	},
	{
		value: '',
		name: 'requesterDetails.email',
		label: 'Work Email Id',
		placeHolder: 'Enter your Email Id',
		type: 'email',
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validEmail,
				msg: 'Enter Valid Email'
			}
		},
		errorOnBlur: true,
		nocHangeError: true,
		isMandatory: true,
		outLabel: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		name: 'requesterDetails.phoneNumber',
		label: 'Mobile No.',
		placeHolder: 'Enter 10 digit Mobile No',
		value: '',
		maxLen: '10',
		validation: {
			required: {
				msg: 'Required!'
			},
			custom: {
				validator: validPhone,
				msg: 'Invalid phone number, must be 10 digits'
			}
		},
		type: 'tel',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		name: 'eventDetails.eventDate',
		label: 'Date of Event',
		placeHolder: 'Date of Event*',
		value: '',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		isOpenTop: true,
		type: 'date',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'oneThird',
		mmtTheme: true,
		format: APPLICATION_CONSTANTS.DATE_FORMAT,
		formatSave: (date) => getDate(date, 'time')
	},
	{
		name: 'eventDetails.budget',
		label: 'Budget Range',
		value: '',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		placeHolder: 'Minimum Rs. 1000 per person',
		isOpenTop: true,
		type: 'number',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'oneThird',
		mmtTheme: true
	},
	{
		name: 'eventDetails.guestCount',
		label: 'No of Guests',
		value: '',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		placeHolder: 'Enter No of Guests',
		isOpenTop: true,
		type: 'number',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'oneThird',
		mmtTheme: true
	},
	{
		name: 'eventDetails.type',
		label: 'Event Type',
		value: '',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		options: [{
			value: 'All day event conference',
			label: {
				labelHead: 'All day event conference'
			}
		},
		{
			value: 'Resident conference',
			label: {
				labelHead: 'Resident conference'
			}
		},
		{
			value: 'Half day event',
			label: {
				labelHead: 'Half day event'
			}
		},
		{
			value: 'Cocktail & Dinner',
			label: {
				labelHead: 'Cocktail & Dinner'
			}
		},
		{
			value: 'High tea or cocktail',
			label: {
				labelHead: 'High tea or cocktail'
			}
		},
		{
			value: 'Meeting room only',
			label: {
				labelHead: 'Meeting room only'
			}
		},
		{
			value: 'Co-working seat space',
			label: {
				labelHead: 'Co-working seat space'
			}
		},
		{
			value: 'Other',
			label: {
				labelHead: 'Other'
			}
		}
		],
		isOpenTop: true,
		type: 'select',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		name: 'eventDetails.foodPreference',
		label: 'Food Preference',
		value: '',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		options: [{
			value: 'Veg food only',
			label: {
				labelHead: 'Veg food only'
			}
		},
		{
			value: 'Veg food with non-alcoholic drinks',
			label: {
				labelHead: 'Veg food with non-alcoholic drinks'
			}
		},
		{
			value: 'Veg & Non Veg food only',
			label: {
				labelHead: 'Veg & Non Veg food only'
			}
		},
		{
			value: 'Veg & Non Veg food with Liquor',
			label: {
				labelHead: 'Veg & Non Veg food with Liquor'
			}
		},
		{
			value: 'Snacks & Liquor',
			label: {
				labelHead: 'Snacks & Liquor'
			}
		},
		{
			value: 'Snacks & Tea/Coffee',
			label: {
				labelHead: 'Snacks & Tea/Coffee'
			}
		}
		],
		isOpenTop: true,
		type: 'select',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		name: 'eventDetails.city',
		label: 'Event City',
		placeHolder: 'Event City',
		value: '',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		isOpenTop: true,
		type: 'text',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		name: 'eventDetails.location',
		label: 'Preferred Event Location',
		value: '',
		placeHolder: 'inside the city',
		validation: {
			required: {
				msg: 'Required!'
			}
		},
		isOpenTop: true,
		type: 'text',
		isMandatory: true,
		outLabel: true,
		errorOnBlur: true,
		customClass: 'half',
		mmtTheme: true
	},
	{
		name: 'eventDetails.additionalDetails',
		label: 'Any Notes for Us ?',
		placeHolder: 'Write it here',
		value: '',
		nocHangeError: true,
		errorOnBlur: true,
		type: 'textArea',
		isMandatory: false,
		mmtTheme: true,
		rows: 2,
		outLabel: true
	}
];

export const chooseMmtBusinessData = {
	heading: 'Why Book Venues with myBiz?',
	descp: 'Get the MakeMyTrip advantage!',
	businessList: [
		{
			width: '200px',
			decp: 'Best Price Guarantee'
		},
		{
			width: '200px',
			decp: 'Block Venue For Free'
		},
		{
			width: '150px',
			decp: 'GST Assured'
		},
		{
			width: '200px',
			decp: '60000+ Meeting Venues'
		}
	]
};

export const QUERY_BTN_TXT = 'GET FREE QUOTE NOW';

export const PAGE_TITLE = 'Venues by MakeMyTrip';

export const QUERY_MODAL = {
	HEADING: 'Tell Us Your Requirements',
	SUBHEADING: 'Just fill out the form, and our team of Venues booking experts will get back to you shortly with suitable options.',
	SUCCESS_HEADING: 'Request Submitted !',
	SUCCESS_DESC1: 'Our representative will contact you within 24 hours to confirm the appointment',
	SUCCESS_DES2: 'To change or cancel the appointment, please contact our customer care.'
};
